module.exports = __webpack_public_path__ + "static/media/73.dc26e7a8.jpg";